<template>

    <v-card width="100%" elevation="0">
        <h2 v-if="documents.length > 0 && !loadingAPI">Trend Articles</h2>
        <v-container fluid class="pa-0 pt-3" v-if="documents.length > 0 && !loadingAPI">
          <v-data-table
              :headers="headers"
              :items="documents"
              :pagination.sync="options"
              class="elevation-1"
              :total-items="numTotalDocuments"
              :loading="loading"
          >
            <template v-slot:items="props">
              <td>{{formatDate(props.item._source["@timestamp"]) }}</td>
              <td>{{ props.item._source.title }}</td>
                  <td><v-chip class="capitalize" v-for="keyword in props.item._source.keywords.slice(0, Math.min(maxKeywordsToShow, props.item._source.keywords.length))">{{keyword}}</v-chip></td>
                  <td>{{ props.item._source.source }}</td>
                  <td class="text-xs-right">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                              class="mr-2"
                              small
                              @click="goTo(props.item._source.document_id)"
                              v-on="on"
                          >
                          open_in_new
                        </v-icon>
                      </template>
                      <span>View on source</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">

                    <v-icon
                        small
                        v-on="on"
                        @click="clickdTableRow(props.item)"
                    >
                      book
                    </v-icon>
                    </template>
                    <span>Preview</span>
                  </v-tooltip>
                  </td>
            </template>

            <template v-slot:no-data>
              <p>No Data found.</p>
            </template>
          </v-data-table>

          <v-dialog
              transition="dialog-bottom-transition"
              max-width="800"
              v-model="documentDetailsDialog" v-if="documentDetailsDialog"
          >
            <v-card>
              <v-card-title class="grey lighten-2">
                <h3>{{selectedDocument._source.title}}</h3>
              </v-card-title>

              <v-card-text>
                <h4>Content</h4>
                {{selectedDocument._source.content}}

                <div class="pt-4" v-if="'keywords' in selectedDocument._source && selectedDocument._source.keywords.length > 0">
                  <h4>Keywords</h4>
                  <template v-for="(metadata, index) in selectedDocument._source.keywords.slice(0, Math.min(15, selectedDocument._source.keywords.length))">
                    <template v-if="index > 0">, </template>
                    <span class="capitalize">{{metadata}}</span>
                  </template>
                  </div>

                <div class="pt-4" v-if="'authors' in selectedDocument._source.metadata && selectedDocument._source.metadata.authors.length > 0">
                  <h4>Authors</h4>
                  <template v-for="(author, index) in selectedDocument._source.metadata.authors">
                    <template v-if="index > 0">, </template>
                    <span>{{author}}</span>
                  </template>
                </div>

              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    text
                    @click="documentDetailsDialog = false"
                >Close</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-container>

    </v-card>


</template>

<script>
import Document from "@/components/Radar/Document";
import ApiService from "@/helpers/APIService";
import TimeService from "../../helpers/TimeService";
import UrlsService from "@/helpers/UrlsService";

export default {
        name: "DocumentList",
        components: {Document, ApiService},
        props: {
          trend: {
            type: Object,
            required: true,
          }},
        data() {
            return {
                loadingAPI: false,
                page: 1,
                loading: true,
                pageSize: 5,
                maxKeywordsToShow: 3,
                options: {},
                numTotalDocuments: 0,
                showTopBar:false,
                documents: [],
                selectedDocument: {},
                documentDetailsDialog: false,
                headers: [
                  { text: 'Publication', align: 'left', value: 'publication', width: "5%"},
                  { text: 'Title', align: 'left', value: 'title', width: "45%"},
                  { text: 'Keywords', align: 'left', value: 'authors', width: "45%"},
                  { text: 'Source', value: '_source.source', width: "6%"},
                  { text: 'Actions', value: 'name', sortable: false, width: "4%" },
                ]
            }
        },
        created() {
          console.log("this_trend",this.trend)
        },
        mounted() {
          this.getDocumentFilteredFromES();
        },
      computed: {
            numPages() {
                return Math.ceil(this.numTotalDocuments / this.pageSize);
            },
            currentStartDocCounter() {
                return this.pageSize * (this.page - 1);
            },
            onPrevPage() {
                if (this.page > 1) {
                    this.page--;
                    //this.getDocumentFilteredFromES(this.currentFilterSettings);
                }
            },
            onNextPage() {
                if (this.page < this.numPages) {
                    this.page++;
                    //this.getDocumentFilteredFromES(this.currentFilterSettings);
                }
            },
            selectFirst5Keywords(keywordsArray){
              console.log(keywordsArray)
              let min = Math.min(5, keywordsArray.length)
              return keywordsArray.slice(0, min);
            }
        },
      watch: {
        options: {
          handler () {
            this.getDocumentFilteredFromES()
          },
          deep: true,
        },
      },
        methods: {
          formatDate(timestamp){
            let date = new Date(timestamp);
            return date.toLocaleDateString()
          },
          clickdTableRow(item){
            this.selectedDocument = item
            this.documentDetailsDialog = true
          },
          goTo(link){
            window.open(link);
          },
          getDocumentFilteredFromES() {

            let _this = this;

            let requestUrl = {
              url: UrlsService.searchTrendDocs,
              timeout: TimeService.secondsToMillis(0),
            };

            let requestFilter = {
                  classes: [this.trend.title],
                  noClasses: false,
                  page: this.page,
                  pageSize: this.pageSize
            }

            if("rowsPerPage" in this.options){
              requestFilter.pageSize = this.options.rowsPerPage
              requestFilter.page = (this.options.page - 1) * (requestFilter.pageSize ) +1
            }

            let requestBody = {
              "page_size": requestFilter.pageSize,
              "from_page": requestFilter.page,
              "filter_classes": requestFilter.classes,
              "add_no_classes": requestFilter.noClasses
            };

            ApiService.superadmin(requestUrl,  requestBody, "post")
                .then ( response => {
                  console.log(response)
                  _this.numTotalDocuments = response.total.value;
                  _this.documents = response.hits
                  _this.loading = false
                })
                .catch ( error => { console.log(error) } )
          },
        }
    }
</script>

<style scoped>
  .capitalize{
    text-transform: capitalize;
  }
</style>
